class StickySidebar extends HTMLElement {
  constructor() {
    super();

    // Initialize properties
    this.topGap = 0;
    this.bottomGap = 0;
    this.currPos = window.scrollY;
    this.screenHeight = window.innerHeight;
    this.stickyElementHeight = 0;
    this.endScroll = 0;

    // Bind methods to the instance
    this._boundUpdateSticky = this.updateSticky.bind(this);
    this._boundHandleResize = this.handleResize.bind(this);
  }

  // Called when the element is added to the DOM
  connectedCallback() {
    this.initSidebar();
    window.addEventListener("scroll", this._boundUpdateSticky, { passive: true });
    window.addEventListener("resize", this._boundHandleResize);
    this.updateSticky();
  }

  // Remove listeners if element is removed
  disconnectedCallback() {
    window.removeEventListener("scroll", this._boundUpdateSticky);
    window.removeEventListener("resize", this._boundHandleResize);
  }

  // Initialize sidebar properties based on attributes
  initSidebar() {
    const navEl = document.querySelector('#topNavigation');
    if (navEl) {
      this.topGap += navEl.offsetHeight;
    }

    if (this.hasAttribute("data-top-gap")) {
      const dataTopGap = this.getAttribute("data-top-gap");
      this.topGap += parseInt(dataTopGap, 10);
    }

    if (this.hasAttribute("data-bottom-gap")) {
      const dataBottomGap = this.getAttribute("data-bottom-gap");
      console.log('dataBottomGap', dataBottomGap)
      this.bottomGap += parseInt(dataBottomGap, 10);
    }

    this.style.top = this.topGap + "px";
    this.stickyElementHeight = this.offsetHeight;
  }

  // Handle window resize events
  handleResize() {
    this.screenHeight = window.innerHeight;
    this.stickyElementHeight = this.offsetHeight;
    this.currPos = window.scrollY;
    this.updateSticky();
  }

  updateSticky() {
    requestAnimationFrame(() => {
      this.screenHeight = window.innerHeight;
      this.stickyElementHeight = this.offsetHeight;
      this.positionStickySidebar();
    });
  }

  // Calculate and set the new position of the sticky sidebar
  positionStickySidebar() {
    this.endScroll = window.innerHeight - this.stickyElementHeight - this.bottomGap;
    let currentTop = parseInt(this.style.top.replace("px", ""), 10);
    let scrollDelta = this.currPos - window.scrollY;
    let newTop;
    if (this.stickyElementHeight + this.topGap + this.bottomGap > this.screenHeight) {
      if (scrollDelta > 0) {
        newTop = Math.min(currentTop + scrollDelta, this.topGap);
      } else {
        newTop = Math.max(currentTop + scrollDelta, this.endScroll);
      }
    } else {
      newTop = this.topGap;
    }

    this.style.top = newTop + "px";
    this.style.bottom = this.bottomGap + "px";
    this.currPos = window.scrollY;
  }
}

customElements.define("sticky-sidebar", StickySidebar);
